/**
 * Constants and function definition responsible for displaying a large styled
 * warning in the browser's console, warning users not to paste any code in.
 */

const CONSOLE_WARNING_MESSAGE =
  "You have accessed the browser's developer console. Do not paste or enter code here, your one-click signer trading keys could be at risk. The Ethereal team will never ask you to paste code here. If someone has instructed you to paste something here, please inform our team on Discord.";

const consoleNoticeStyle = [
  'font-family: ui-monospace, monospace',
  'padding: 24px',
  'font-size: 28px',
  'font-weight: 800',
  'border-radius: 4px',
  'letter-spacing: 0.05em',
];

const headingStyle = [
  ...consoleNoticeStyle,
  'background: linear-gradient(90deg, #000000, #3c4046)', // black to neutral-500
  'color: #f0f0f0', // contentPrimary
].join(';');

const warningStyle = [
  ...consoleNoticeStyle,
  'background: #df6a70', // contentRed
  'color: #0d0f11', // contentInversePrimary
].join(';');

const isDarkMode =
  typeof window !== 'undefined' &&
  window.matchMedia &&
  window.matchMedia('(prefers-color-scheme: dark)').matches;

const messageStyle = [
  'font-size: 16px',
  'line-height: 1.6',
  'font-family: system-ui, sans-serif',
  'padding: 16px',
  `background: ${isDarkMode ? '#0d0f11' : '#f8fafc'}`, // dark: slate-900, light: slate-50
  `color: ${isDarkMode ? '#f0f0f0' : '#0d0f11'}`, // dark: slate-50, light: slate-900
  'border-left: 8px solid #df6a70',
].join(';');

export const logConsoleWarning = () => {
  console.log('%c   ETHEREAL   ', headingStyle);
  console.log('%cSECURITY ALERT', warningStyle);
  console.log(`%c${CONSOLE_WARNING_MESSAGE}`, messageStyle);
};
